import { FirebaseDependency } from '@/firebase';
import { vuexEasyFirestore } from 'vuex-easy-firestore';
import { argumentsModule } from '@//store/modules/argumentsModule';
import { commentsModule } from '@//store/modules/commentsModule';
import { displayModule } from '@//store/modules/displayModule';
import { documentsModule } from '@//store/modules/documentsModule';
import { mainModule } from '@//store/modules/mainModule';
import { notificationsModule } from '@//store/modules/notificationsModule';
import { routerModule } from '@//store/modules/routerModule';
import { sectionsModule } from '@//store/modules/sectionsModule';
import { usersModule } from '@//store/modules/usersModule';
import { votingModule } from '@/store/modules/votingModule';
import { changeEventsModule } from '@/store/modules/changeEventsModule';

export default (module: any): void => {
  console.log("Decorate with Firestore");
  // @ts-ignore
  const easyFirestore = vuexEasyFirestore([sectionsModule, argumentsModule, mainModule, usersModule, commentsModule, changeEventsModule, documentsModule], {
    logging: process.env.NODE_ENV !== 'production',
    FirebaseDependency,
  });
  module.plugins = [easyFirestore];
  module.modules = {
    routerModule,
    displayModule,
    notificationsModule,
    votingModule
  };
}
